import { BaseReducer } from '@identic/api';
import { LocationState, LocationInitialState, LocationActions } from './location.state';

export function LocationReducer(state: LocationState = LocationInitialState, action: any): LocationState {
  return BaseReducer(state, action, LocationActions);
}
// console.log(`%cLocationReducer::ngOnInit`, 'background:yellow');
